/**
 * `platform` — the one object the app talks to for native capability.
 *
 * `import.meta.env.VITE_PLATFORM` is replaced with a string literal at build
 * time (vite.config.ts pins it), so the comparison below folds to a constant
 * and Rollup drops whichever implementation is not selected. The production
 * web bundle therefore contains no native code, and the native bundle no
 * web-only fallbacks.
 */
import type { Platform } from './types';
import { webPlatform } from './web';
import { nativePlatform } from './native';

export const IS_NATIVE: boolean = import.meta.env.VITE_PLATFORM === 'native';

export const platform: Platform = IS_NATIVE ? nativePlatform : webPlatform;

export type {
  AppVersion,
  BiometricOutcome,
  GeoError,
  GeoErrorCode,
  GeoOptions,
  GeolocationCoords,
  KeyValueStore,
  Platform,
  PlatformKind,
  PushMessage,
  PushPermission,
  PushToken,
  SharePayload,
  Unsubscribe,
} from './types';
